import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
  Paper,
  Container,
} from '@mui/material';
import { Error as ErrorIcon, Home } from '@mui/icons-material';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '80vh',
          textAlign: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: { xs: 3, sm: 5 },
            borderRadius: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            maxWidth: 500,
          }}
        >
          <ErrorIcon
            color="error"
            sx={{
              fontSize: 80,
              mb: 3,
            }}
          />

          <Typography variant="h4" component="h1" gutterBottom color="primary">
            Səhifə Tapılmadı
          </Typography>

          <Typography variant="body1" color="text.secondary" paragraph>
            Axtardığınız səhifə mövcud deyil və ya silinib.
          </Typography>

          <Typography variant="body2" color="text.secondary" paragraph>
            URL-i yoxlayın və ya ana səhifəyə qayıdın.
          </Typography>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              startIcon={<Home />}
              onClick={() => navigate('/app')}
              sx={{ mr: 2 }}
            >
              Ana Səhifə
            </Button>

            <Button
              variant="outlined"
              onClick={() => window.history.back()}
            >
              Geri Qayıt
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default ErrorPage;
